import http from "../http-common";
import authHeader from "./authHeader";
import { EDITS_API } from "../api";
import CustomerService from "./customerService";
const getAllFormEdits = () => {
  return http.get(`/api/v1/edits`, { headers: authHeader() });
};

const getAllDraftFormEdits = () => {
  return http.get(`/api/v1/edits/drafts-edits`, { headers: authHeader() });
};

// const getDrafts = () => {
//   return http.get(`/api/v1/edits/drafts-edits`, { headers: authHeader() });
// };
const getFormEditById = (id) => {
  return http.get(`/api/v1/edits/${id}`, { headers: authHeader() });
};

const getFormEditByCustomerAnType = (id, data) => {
  return http.post(`/api/v1/edits/customer/type/${id}`, data, {
    headers: authHeader(),
  });
};

const createFormEdit = (data) => {
  return http.post(`/api/v1/edits`, data, {
    headers: authHeader(),
    "Content-Type": "multipart/form-data",
  });
};

const approveForm = (id, data) => {
  return http.put(
    `/api/v1/edits/approve/${id}`,
    { isDraft: false },
    { headers: authHeader(), "Content-Type": "multipart/form-data" }
  );
};

const resignFormEdit = (id) => {
  return http.put(
    `/api/v1/edits/${id}`,
    { role: null },
    { headers: authHeader() }
  );
};

const assignFormEdit = (id, role) => {
  return http.put(`/api/v1/edits/${id}`, { role }, { headers: authHeader() });
};
const updateFormEdit = (id, data) => {
  return http.put(`/api/v1/edits/${id}`, data, { headers: authHeader() });
};
// const updateFormEditFormDraft = (id, data) => {
//   return http.put(`/api/v1/edits/${id}/draft`, data, { headers: authHeader() });
// };

const removeFormEdit = (id) => {
  return http.delete(`/api/v1/edits/${id}`, { headers: authHeader() });
};

const FormEditService = {
  getAllFormEdits,
  getFormEditById,
  createFormEdit,
  updateFormEdit,
  removeFormEdit,
  resignFormEdit,
  assignFormEdit,
  getAllDraftFormEdits,
  getFormEditByCustomerAnType,
  approveForm,
};

export default FormEditService;
